<template>
  <div class="min-h-full sticky top-0 z-50" v-if="getnavbar">
    <div
      as="nav"
      class="border-b border-gray-200 dark:border-dtheme-700 bg-white dark:bg-dtheme-900"
    >
      <div class="mx-auto px-3 sm:px-6 lg:px-3">
        <div class="flex h-10 sm:h-16 justify-between">
          <div class="flex justify-center items-center">
            <div class="hidden sm:block">
              <div class="app-logo-dark hidden sm:block w-40 mr-20">
                <img src="@/assets/definedge-dark-logo.png" />
              </div>
              <div class="app-logo-light hidden sm:block w-40 mr-20">
                <img src="@/assets/definedge-light-logo.png" />
              </div>
            </div>
            <button
              type="button"
              class="-m-2.5 p-2.5 text-gray-700"
              @click="toggleSideBar()"
            >
              <Bars3Icon class="h-6 w-6 dark:text-white" aria-hidden="true" />
            </button>
            <!-- <div
              class="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8 dark:text-white"
            >
              <h1>Definedge Securities Dashboard</h1>
            </div> -->
            <div
              class="hidden sm:flex items-center ml-4 text-left text-sm font-semibold text-slate-600 dark:text-gray-200 capitalize"
            >
              <div>
                <div
                  class="text-sm font-semibold text-slate-700 dark:text-white capitalize"
                >
                  Hello
                  {{
                    firstname.charAt(0).toUpperCase() +
                    firstname.slice(1).toLowerCase()
                  }}
                  :
                  <span
                    class="font-medium text-slate-700 dark:text-slate-300"
                    >{{ ucc }}</span
                  >
                </div>
                <div class="text-xs text-slate-600 dark:text-slate-300">
                  Welcome to the Stock Market Ecosystem of Definedge Securities
                </div>
              </div>
            </div>
          </div>
          <div class="hidden sm:ml-6 sm:flex sm:items-center gap-2">
            <div
              v-if="manager"
              class="relative inline-block text-left"
              @mouseover="open = true"
              @mouseleave="open = false"
            >
              <!-- Button -->
              <button
                class="btn-donate btn-km inline-flex items-center justify-center font-medium px-3 py-2 text-sm"
                :style="{
                  '--btn-bg-1': manager.category || 'hsla(194,100%,69%,1)',
                  '--btn-bg-2': adjustColor(manager.category || '#155DFC', -20),
                }"
              >
                My Knowledge Manager
                <svg
                  class="ml-1 mt-0.5 w-4 h-4 transform transition-transform duration-200"
                  :class="{ 'rotate-180': open }"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              <!-- Dropdown -->
              <transition
                enter-active-class="transition ease-out duration-150"
                enter-from-class="opacity-0 translate-y-1"
                enter-to-class="opacity-100 translate-y-0"
                leave-active-class="transition ease-in duration-100"
                leave-from-class="opacity-100 translate-y-0"
                leave-to-class="opacity-0 translate-y-1"
              >
                <div
                  v-if="open"
                  class="absolute right-0 mt-2 w-56 rounded-lg z-50 p-3 bg-blue-50 dark:bg-dtheme-800 border-2 border-slate-500"
                >
                  <!-- Name -->
                  <p
                    class="pl-2 text-xs font-normal mb-1 text-slate-600 dark:text-gray-400"
                  >
                    Name:
                  </p>
                  <p
                    class="pl-2 text-sm font-medium mb-2 text-slate-700 dark:text-slate-300"
                  >
                    {{ manager.name }}
                  </p>
                  <hr
                    class="my-2 border border-slate-300 dark:border-slate-600"
                  />

                  <!-- Contact -->
                  <p
                    class="pl-2 text-xs font-normal mb-1 text-slate-600 dark:text-gray-400"
                  >
                    Contact:
                  </p>
                  <p
                    class="pl-2 text-sm font-medium text-slate-700 dark:text-slate-300"
                  >
                    {{ manager.contact }}
                  </p>
                </div>
              </transition>
            </div>
            <a
              href="https://www.definedgesecurities.com/get-started/"
              target="_blank"
              rel="noopener noreferrer"
              class="btn-donate btn-km inline-flex items-center gap-2 px-4 py-2 font-medium text-sm rounded-md shadow transition duration-200"
              style="--btn-bg-1: #4f46e5; --btn-bg-2: #2563eb"
            >
              Start Exploring
            </a>
            <button
              type="button"
              class="text-gray-400 inline-flex justify-center items-center gap-x-1.5 rounded-md bg-white p-2 h-10 w-10 shadow-sm ring-1 ring-inset ring-gray-500 hover:bg-gray-50 dark:text-white dark:bg-dtheme-700 dark:ring-black-300"
              @click="toggleDark()"
            >
              <!-- <MoonIcon
                class="h-6 w-6 text-gray-500 dark:text-black-200"
                aria-hidden="true"
              /> -->
              <div class="moon-icon">
                <img src="@/assets/moon-dark.svg" />
              </div>
              <div class="sun-icon">
                <img src="@/assets/sun-light.svg" class="text-slate-500" />
              </div>
            </button>
            <!-- Profile dropdown -->
            <Menu as="div" class="relative inline-block text-left">
              <div>
                <MenuButton
                  class="inline-flex justify-center items-center gap-x-1.5 rounded-md bg-white p-2 h-10 w-10 text-sm font-medium text-gray-900 shadow-sm ring-1 ring-inset ring-gray-500 hover:bg-gray-50 dark:text-white dark:bg-dtheme-700 dark:ring-black-300"
                >
                  {{ initials }}
                </MenuButton>
              </div>

              <transition
                enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
              >
                <MenuItems
                  class="absolute right-0 z-10 mt-2.5 origin-top-right divide-y divide-gray-100 dark:divide-black-300 rounded-md shadow-xl px-4 py-2 border border-gray-200 dark:border-black-300 bg-white dark:bg-dtheme-700"
                >
                  <div class="py-2 text-left text-gray-500 text-sm">
                    {{ firstname }}
                  </div>
                  <div class="py-2 text-left text-gray-500 text-sm">
                    {{ email }}
                  </div>
                  <div
                    class="py-2 flex items-center justify-start text-sm cursor-pointer"
                  >
                    <MenuItem v-slot="{ active }">
                      <a
                        @click="onLogout()"
                        :class="[
                          active ? ' text-gray-500' : 'text-gray-700',
                          'group flex items-center text-sm text-gray-400 dark:text-white',
                        ]"
                      >
                        <ArrowRightOnRectangleIcon
                          class="mr-3 h-5 w-5"
                          aria-hidden="true"
                        />
                        Sign Out
                      </a>
                    </MenuItem>
                  </div>
                </MenuItems>
              </transition>
            </Menu>
          </div>
          <div class="items-center hidden sm:hidden">
            <!-- Mobile menu button -->
            <Menu as="div" class="relative inline-block text-left">
              <div>
                <MenuButton
                  class="inline-flex w-full justify-center gap-x-1.5 rounded-full bg-white px-2 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                >
                  {{ initials }}
                </MenuButton>
              </div>

              <transition
                enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
              >
                <MenuItems
                  class="absolute right-0 z-10 mt-2.5 origin-top-right divide-y divide-gray-100 dark:divide-black-300 rounded-md shadow-xl px-4 py-2 border border-gray-200 dark:border-black-300 bg-white dark:bg-dtheme-700"
                >
                  <div class="py-2 text-left text-gray-500 text-sm">
                    {{ firstname }}
                  </div>
                  <div class="py-2 text-left text-gray-500 text-sm">
                    {{ email }}
                  </div>
                  <div
                    class="py-2 flex items-center justify-start text-sm cursor-pointer"
                  >
                    <MenuItem v-slot="{ active }">
                      <a
                        @click="onLogout()"
                        :class="[
                          active ? ' text-gray-500' : 'text-gray-700',
                          'group flex items-center text-sm text-gray-400 dark:text-white',
                        ]"
                      >
                        <ArrowRightOnRectangleIcon
                          class="mr-3 h-5 w-5"
                          aria-hidden="true"
                        />
                        Sign Out
                      </a>
                    </MenuItem>
                  </div>
                </MenuItems>
              </transition>
            </Menu>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  reactive,
  toRefs,
  ref,
  defineComponent,
  computed,
  onMounted,
  watch,
} from "vue";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
// import { MoonIcon } from "@heroicons/vue/24/outline";
import { useUserStore } from "../store/user";
import { ArrowRightOnRectangleIcon, Bars3Icon } from "@heroicons/vue/20/solid";
import { useCommonStore } from "@/store/commonStore";
import { useDark, useToggle } from "@vueuse/core";
export default defineComponent({
  components: {
    // MoonIcon,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    ArrowRightOnRectangleIcon,
    Bars3Icon,
  },
  setup() {
    const isDark = useDark();
    const toggleDark = useToggle(isDark);
    const userStore = useUserStore();
    const commonStore = useCommonStore();
    const state = reactive({
      getnavbar: computed(() => commonStore.getNavbar),
      email: computed(() => userStore.username.email),
      ucc: computed(() => userStore.username.ucc),
      firstname: computed(
        () => userStore.username.firstname + " " + userStore.username.lastname
      ),
      // initials: computed(() => {
      //   console.log("user is : ", userStore?.username);
      //   const fullnameArray = userStore?.username.firstname?.split("");
      //   console.log("initial letter : ", fullnameArray?.[0]?.split("")?.[0]);
      //   const firstchar = fullnameArray?.[0]?.split("")?.[0];
      //   const secondchar = fullnameArray?.[1]?.split("")?.[0];
      //   const finalchar = firstchar + secondchar;
      //   console.log("initial letter final : ", finalchar);
      //   return finalchar;
      // }),
      initials: computed(() => {
        console.log("user is : ", userStore?.username);
        const firstName = userStore?.username?.firstname || "";
        const lastName = userStore?.username?.lastname || "";
        const firstChar = firstName.charAt(0) || "";
        const secondChar = lastName.charAt(0) || "";
        const finalChar = firstChar + secondChar;
        console.log("Initials: ", finalChar);
        return finalChar;
      }),
    });
    const toggleSideBar = () => {
      commonStore.sidebarOpen = !commonStore.sidebarOpen;
    };
    const onLogout = () => {
      window.location.assign("/logout");
    };
    const open = ref(false);
    watch(
      () => userStore.username.km,
      (newVal) => {
        if (newVal) {
          const message =
            "Name: " +
            newVal.name +
            "\nContact: " +
            newVal.contact +
            "\nCategory: " +
            newVal.category;
          console.log("KM :\n" + message);
        }
      },
      { immediate: true }
    );

    // PROD
    const manager = computed(() => {
      const km = userStore.username.km;
      if (!km) return null;
      return km;
    });

    // TEST
    // const manager = computed(() => {
    //   const km = userStore.username.km;

    //   if (!km) {
    //     return {
    //       name: "Raju Ranjan",
    //       contact: "7276753434",
    //       category: "#D4AF37",
    //     };
    //   }

    //   // fallback if some fields are missing individually
    //   return {
    //     name: km.name || "Default Manager",
    //     contact: km.contact || "9999999999",
    //     category: km.category || "#D4AF37",
    //   };
    // });

    function toggleDropdown() {
      open.value = !open.value;
    }

    function adjustColor(color, amount) {
      try {
        const col = color.startsWith("#") ? color.slice(1) : color;
        let num = parseInt(col, 16);
        let r = (num >> 16) + amount;
        let g = ((num >> 8) & 0x00ff) + amount;
        let b = (num & 0x0000ff) + amount;
        r = Math.max(Math.min(255, r), 0);
        g = Math.max(Math.min(255, g), 0);
        b = Math.max(Math.min(255, b), 0);
        return `rgb(${r}, ${g}, ${b})`;
      } catch {
        return color;
      }
    }

    onMounted(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const theme = urlParams.get("theme");

      if (theme === "dt" && !isDark.value) {
        toggleDark();
      } else if (theme === "lt" && isDark.value) {
        toggleDark();
      } else if (!theme && isDark.value) {
        toggleDark();
      }
    });
    return {
      ...toRefs(state),
      onLogout,
      toggleSideBar,
      toggleDark,
      toggleDropdown,
      open,
      manager,
      adjustColor,
    };
  },
});
</script>
<style scoped>
/* Uiverse.io Gradient Button Style */
.btn-donate {
  --clr-font-main: hsla(0 0% 20% / 100);
  --btn-bg-1: hsla(194 100% 69% / 1);
  --btn-bg-2: hsla(217 100% 56% / 1);
  --btn-bg-color: hsla(360 100% 100% / 1);
  --radii: 0.5em;
  cursor: pointer;

  /*  Reduced size */
  padding: 0.6em 1em;
  min-width: 90px;
  min-height: 36px;
  font-size: 0.9rem;
  font-weight: 500;

  transition: 0.8s;
  background-size: 280% auto;
  background-image: linear-gradient(
    325deg,
    var(--btn-bg-2) 0%,
    var(--btn-bg-1) 55%,
    var(--btn-bg-2) 90%
  );
  border: none;
  border-radius: var(--radii);
  color: var(--btn-bg-color);
}

.btn-donate:hover {
  background-position: right top;
  transform: scale(1.03);
}

.btn-km {
  position: relative;
  overflow: hidden;
}

/* Inner glow (from inside, soft light) */
.btn-km::before {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(
    circle at 30% 30%,
    rgba(255, 255, 255, 0.35),
    transparent 60%
  );
  mix-blend-mode: screen;
  transition: opacity 0.4s ease;
  opacity: 0.5;
}

/* Smooth animated light sweep */
.btn-km::after {
  content: "";
  position: absolute;
  top: 0;
  left: -75%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    120deg,
    rgba(255, 255, 255, 0.2) 0%,
    rgba(255, 255, 255, 0.6) 50%,
    rgba(255, 255, 255, 0.2) 100%
  );
  transform: skewX(-20deg);
  animation: shineSweep 3s infinite;
}

/* On hover — thoda extra shine */
.btn-km:hover::before {
  opacity: 0.8;
}
</style>
